"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = require("styled-components");
var _normalize = _interopRequireDefault(require("./normalize"));
var _base = _interopRequireWildcard(require("./base"));
var _simplebar = _interopRequireDefault(require("./simplebar"));
var _DatePicker = _interopRequireDefault(require("./components/DatePicker"));
var _Select = _interopRequireDefault(require("./components/Select"));
var _Dropdown = _interopRequireDefault(require("./components/Dropdown"));
var _Tooltip = _interopRequireDefault(require("./components/Tooltip"));
var _index = _interopRequireDefault(require("./fonts/index"));
var _gridGlobalStyles = _interopRequireDefault(require("../../Grid/gridGlobalStyles"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var GlobalStyle = (0, _styledComponents.createGlobalStyle)(["", " ", " ", " ", " ", " ", " ", " ", " ", ""], _normalize.default, function (props) {
  return props.theme.appname === 'sparx' ? (0, _base.sparxBase)(props) : (0, _base.default)(props);
}, _gridGlobalStyles.default, _simplebar.default, function (props) {
  return !props.theme.customFont && _index.default[props.theme.appname || 'opensans'](props.theme.cdn.fontUrl);
}, function (props) {
  return (0, _DatePicker.default)(props);
}, function (props) {
  return (0, _Select.default)(props);
}, function (props) {
  return (0, _Dropdown.default)(props);
}, function (props) {
  return (0, _Tooltip.default)(props);
});
var _default = exports.default = GlobalStyle;